var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button",class:[
    { 'button--white': _vm.white },
    { 'button--whitePink': _vm.whitePink },
    { 'button--whiteBlue': _vm.whiteBlue },
    { 'button--blueWhite': _vm.blueWhite },
    { 'button--gray': _vm.gray },
    { 'button--dark': _vm.dark },
    { 'button--purple': _vm.purple },
    { 'button--cancel': _vm.cancel },
    { 'button--pinkTwism': _vm.pinkTwism },
    { 'button--blueTwism': _vm.blueTwism },
    { 'button--secundary-blue': _vm.secundaryBlue },
    { 'button--link': _vm.link },
    { 'button--big': _vm.big },
    { 'button--secondary': _vm.secondary },
    { 'button--tertiary': _vm.tertiary },
    { 'button--quartenary': _vm.quartenary },
    { 'button--quintenary': _vm.quintenary },
    { 'button--lightBlue': _vm.lightBlue },
    { 'button--senary': _vm.senary },
    { 'button--small': _vm.small },
    { 'button--outline-blue': _vm.outlineBlue },
    { 'button--secondary-new': _vm.secondaryNew },
    { disabled: _vm.disabled },
    { loading: _vm.loading }
  ],on:{"click":_vm.clicked}},[(_vm.loading)?_c('div',{staticClass:"loader-default"}):_vm._e(),(this.$props.icon !== undefined)?_c('span',{staticClass:"button__icon icon",class:[("icon-" + _vm.icon), { 'button__icon--bigger': _vm.biggerIcon }]}):_vm._e(),(!_vm.loading)?_c('span',{staticClass:"button__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }